import { render } from "./RecommendationResults.vue?vue&type=template&id=915917e8&scoped=true"
import script from "./RecommendationResults.vue?vue&type=script&lang=js"
export * from "./RecommendationResults.vue?vue&type=script&lang=js"

import "./RecommendationResults.vue?vue&type=style&index=0&id=915917e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-915917e8"]])

export default __exports__